/**
 * Canonical identity model for "region-like" options used across the UI.
 *
 * Why this exists:
 * - Template region definitions can have duplicate schemaRegionKey values and must remain distinct.
 * - Schema-only region options (no _id) must still be selectable and persistable.
 * - Block-owned regions in edit flows are always _id-identified.
 */
 
export function regionRefKey(ref) {
    if (!ref || typeof ref !== 'object') return '';
    if (ref.kind === 'template') return `template:${String(ref.id)}`;
    if (ref.kind === 'schema') return `schema:${String(ref.key)}`;
    if (ref.kind === 'blockOwned') return `blockOwned:${String(ref.id)}`;
    return '';
}

export function regionRefsEqual(a, b) {
    return regionRefKey(a) !== '' && regionRefKey(a) === regionRefKey(b);
}

/**
 * Convert a region object into a stable RegionRef, given its source.
 *
 * @param {object} region
 * @param {'template'|'schema'|'blockOwned'} kindHint
 */
export function toRegionRef(region, kindHint) {
    if (!region || typeof region !== 'object') return null;
    if (kindHint === 'schema') {
        const key = region.schemaRegionKey ?? region.key;
        return key ? { kind: 'schema', key: String(key) } : null;
    }
    const id = region._id;
    if (!id) return null;
    if (kindHint === 'blockOwned') return { kind: 'blockOwned', id: String(id) };
    return { kind: 'template', id: String(id) };
}

export function isTemplateRegion(region) {
    return !!(region && typeof region === 'object' && region._id && (region.bdsaBlockId == null));
}

export function isBlockOwnedRegion(region) {
    return !!(region && typeof region === 'object' && region._id && (region.bdsaBlockId != null));
}

